// HTTP请求工具类
import axios from 'axios';
import router from '../router'
import store from '@/store'  // 导入store
let BASE_URL = '';
// 开发环境
if(process.env.NODE_ENV == 'development'){
  BASE_URL = process.env.VUE_APP_API_BASE_URL
}else{
  BASE_URL = window.location.origin + '/complaint_data_service'
}

const xsrfHeaderName = 'Authorization'

// 创建axios实例
const request = axios.create({
  baseURL: BASE_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
    // 'CHANNEL-CODE': store.state.channel.channelCode || sessionStorage.getItem('weidun_channel_code')
  },
});

// 请求拦截器
request.interceptors.request.use(
  config => {
    let userId = store.state.user.userInfo ? store.state.user.userInfo.id : generateBrowserUserId()
    let token = localStorage.getItem('web_login_token')
    token && (config.headers[xsrfHeaderName] ='Bearer ' + token);
    config.headers['ts'] = +new Date();
    config.headers['CHANNEL-CODE'] = store.state.channel.channelCode || sessionStorage.getItem('weidun_channel_code');
    config.headers['USER-ID'] = userId
    return config;
  },
  error => {
    return Promise.reject(error);
  },
);

// 响应拦截器
request.interceptors.response.use(
  response => {
    let { config:{ url } } = response
    if(response.status == 403){
      let redirect = window.location.href && window.location.href.split('#')[1]
      // 清除token
      localStorage.removeItem('web_login_token')
      sessionStorage.removeItem('store')
      if(redirect && redirect.indexOf('/login') == -1){
          // 跳转登录页
          router.replace('/login')
      }
    }

    if(response.data.code == 40001){
      let redirect = window.location.href && window.location.href.split('#')[1]
      // 清除token
      localStorage.removeItem('web_login_token')
      sessionStorage.removeItem('store')
      if(redirect && redirect.indexOf('/login') == -1){
        // 跳转登录页
        router.replace('/login')
      }
    }

    return response.data;
  },
  error => {
    if(error.response){
      switch (error.response.status){
          case 500:
              message.error(error.response.data.message);
              break;
          case 403:
              let redirect = window.location.href && window.location.href.split('#')[1]
              // 清除token
              localStorage.removeItem('web_login_token')
              sessionStorage.removeItem('store')
              if(redirect && redirect.indexOf('/login') == -1){
                  // 跳转登录页
                  router.replace('/login')
              }
              break;
          // case 404:
          //     message.error('服务不通');
          //     break;
      }
    }
    return Promise.reject(new Error(message));
  },
);

export default request;
